import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "space-between",
    padding: 16,
  },
  infoText: {
    marginBottom: 32,
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#aaa",
    paddingVertical: 8,
  },
  textBold: {
    fontWeight: "bold",
  },
  input: {
    color: "green",
    fontSize: 24,
  },
  summary: {
    marginTop: 16,
    marginBottom: 32,
  },
  spaceBetween: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  textBold: {
    fontWeight: "bold",
    fontSize: 16
  },
  copyText: {
    color: "#256df4",
    fontSize: 16
  },
  walletInput: {
    borderBottomWidth: 1,
    borderBottomColor: "#aaa",
    height: 36,
  },
});
